export default function reportTypeDirective() {
  return {
    template: require('./report-type.html'),
    controller: 'SRReportTypeController',
    controllerAs: 'srReportTypeVM',
    bindToController: true,
    replace: true,
    scope: {
      customerId: '@',
      reportType: '=',
    },
  };
}
